/*
 * @Description: 二级城市招聘时间和地点组件
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-02-08 13:45:46
 * @LastEditors  : zhouhong07
 * @LastEditTime : 2020-02-15 21:19:28
 */
import React, { useEffect, useState } from 'react' ;
import { cityPageTimePlace } from '../../util/api';
import { getCid } from '../../util/helper';

const CityNotice = () => {
  const [data, setData] = useState({});
  const [flag, setflag] = useState(0) ;
  let temp = decodeURI(window.location.hash).split(":")[1];
  let city = temp.length > 0 ? temp.split("_")[0] : getCid() ;
  useEffect(async () => {
    let res = await cityPageTimePlace(city);
    setData(res);
    if(res.start_time || res.address){
      setflag(1);
    }
    // console.log('res3333',res);
  },[]);
  return(
    (Object.keys(data).length > 0) && (flag)?
    <div className="city-notice-block">
      <div className="city-notice-block-left">
        <p>线下招聘会时间</p>
        <p>{data.start_time}</p>
      </div>
      <div className="city-notice-block-right">
        <p>地点</p>
        <p>{data.address}</p>
      </div>
    </div>
    : ""
  )
}

export default CityNotice ;
